module.exports = __webpack_public_path__ + "img/logo_white.eb18378e.png";